module.exports = __webpack_public_path__ + "img/services1.jpg?7c8d989bef4ae91bf946dea39dd4b431";